var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('classification-notice',{staticClass:"fixed-top"}),_c('div',{attrs:{"id":"content-wrapper"}},[_c('nav-bar'),_c('router-view')],1),_c('dhs-footer'),_c('classification-notice',{staticClass:"fixed-bottom"}),_c('inactive-warning-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }